(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/svg/assets/javascripts/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/tb-ui/svg/assets/javascripts/helpers/handlebars-helpers.js');
"use strict";


(function (svs) {
  'use strict';

  var shared;
  if (typeof exports === 'object') {
    shared = require('../shared.es6');
    registerHelpers(require('hbs'));
  } else {
    shared = svs.tb_ui.svg;
    registerHelpers(Handlebars);
  }
  function registerHelpers(hbs) {
    hbs.registerHelper('tb_ui_svg_getSVG', function (svg, size) {
      var options = arguments[arguments.length - 1],
        svgUrl = shared.getSVG(svg, size);
      return options.fn(this, {
        data: options.data,
        blockParams: [svgUrl]
      });
    });
  }
})(svs);

 })(window);